import React from 'react';
const bonuses = [{
  num: '1',
  value: '€27',
  title: 'Dolci & Snack Senza Peccato (100+ Idee)',
  desc: 'Appaga la tua voglia di dolce senza causare picchi glicemici o gonfiore intestinale.'
}, {
  num: '2',
  value: '€17',
  title: 'Lista della Spesa Premium (Digitale)',
  desc: 'Categorizzata "Senza Glutine e Senza Zucchero" per entrare e uscire dal supermercato in 15 min.'
}, {
  num: '3',
  value: '€27',
  title: 'Ricettario Airfryer & Fast Cook',
  desc: 'Piatti croccanti, sani e veloci con la tua friggitrice ad aria.'
}, {
  num: '4',
  value: '€27',
  title: 'Guida "Senza" al Ristorante',
  desc: 'Come goderti la vita sociale e i ristoranti italiani senza rovinare i tuoi progressi.'
}];
export function BonusSection() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-sage-light" data-id="element-18">
      <div className="max-w-2xl mx-auto" data-id="element-19">
        <div className="text-center mb-5 sm:mb-8 flex flex-col items-center" data-id="element-20">
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-text-main mb-2" data-id="element-21">
            🎁 4 BONUS ESCLUSIVI INCLUSI (SOLO OGGI)
          </h2>
          <p className="text-sm sm:text-base text-brand-text-muted font-bold" data-id="element-22">
            Valore totale dei Bonus: €98 — OGGI GRATIS
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-brand-gold/30 p-4 sm:p-5 rounded-xl" data-id="element-24">
              <div className="flex items-center gap-2 mb-2" data-id="element-25">
                <span className="text-brand-gold font-black text-xs tracking-widest" data-id="element-26">
                  BONUS {bonus.num}
                </span>
                <span className="text-brand-text-muted/50" data-id="element-27">|</span>
                <span className="text-xs font-black text-brand-gold uppercase" data-id="element-28">
                  Valore {bonus.value} — GRATIS
                </span>
              </div>
              <h3 className="text-sm sm:text-base font-bold text-brand-text-main leading-tight mb-1" data-id="element-29">
                {bonus.title}
              </h3>
              <p className="text-xs sm:text-sm text-brand-text-muted font-medium leading-snug" data-id="element-30">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}